export type DetailsDataConfig = {
  key?: string;
  label: string;
  value: unknown;
  fullWidth?: boolean;
  isImaging?: boolean;
};

export enum UsersNetworkIdsPanel {
  SECONDARY_DATA_STEWARDS = 'secondary_data_owners',
  DATA_UPLOADERS = 'data_uploaders',
}
